export default __webpack_public_path__ + "static/media/Css.19c8605d.png";